import React from 'react';
import {
  ArrowTopRightOnSquareIcon,
  PencilSquareIcon,
  TrashIcon,
  VideoCameraIcon,
} from '@heroicons/react/24/outline';

interface EventActionsProps {
  meetingLink?: string | null;
  htmlLink?: string | null;
  canEdit: boolean;
  canDelete: boolean;
  onEdit: () => void;
  onDelete: () => void;
}

const EventActions: React.FC<EventActionsProps> = ({
  meetingLink,
  htmlLink,
  canEdit,
  canDelete,
  onEdit,
  onDelete,
}) => {
  return (
    <div className="flex flex-wrap items-center gap-2">
      {meetingLink && (
        <a
          href={meetingLink}
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-primary btn-sm inline-flex items-center gap-2 active:scale-[0.97] transition-transform"
        >
          <VideoCameraIcon className="w-4 h-4" />
          Join meeting
        </a>
      )}
      {canEdit && (
        <button
          type="button"
          onClick={onEdit}
          className="btn btn-outline btn-sm inline-flex items-center gap-2 active:scale-[0.97] transition-transform"
        >
          <PencilSquareIcon className="w-4 h-4" />
          Edit
        </button>
      )}
      {canDelete && (
        <button
          type="button"
          onClick={onDelete}
          className="btn btn-ghost btn-sm inline-flex items-center gap-2 text-error-500 active:scale-[0.97] transition-transform"
        >
          <TrashIcon className="w-4 h-4" />
          Delete
        </button>
      )}
      {htmlLink && (
        <a
          href={htmlLink}
          target="_blank"
          rel="noopener noreferrer"
          className="ml-auto inline-flex items-center gap-1.5 text-sm text-primary-500 hover:underline"
        >
          <ArrowTopRightOnSquareIcon className="w-4 h-4" />
          Open in Google Calendar
        </a>
      )}
    </div>
  );
};

export default EventActions;
